import React, { PureComponent, Fragment } from "react";
import { CheckBoxComponent } from '@syncfusion/ej2-react-buttons';
import Cookies from 'js-cookie';

import CalendarMenu from '../calendarmenu/calendarmenu';
import { TYPE_ROLE_CALENDAR } from "../../../../constants";

export class CalendarItem extends PureComponent {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
    this.state = {
      css: this.makeid(5)
    };
  }

  onClick(evt) {
    const storedSelection = Cookies.get(`Lefebvre.ImapCalendarsSelection`);
    let newCalIds;
    let cookie = false;

    if (storedSelection) {
      const calIds = storedSelection.split('|');

      if (calIds.find(calId => calId === this.props.id) && this.ownerObj.checked === false) {
        //Remove calendar id from cookie list
        newCalIds = '';

        calIds.forEach(id => {
          if (id !== this.props.id && id !== '') {
            newCalIds += `${id}|`;
          }
        });

        cookie = true;
      } else if (!calIds.find(calId => calId === this.props.id) && this.ownerObj.checked === true) {
        // Add calendar id to cookie list
        newCalIds = `${storedSelection}${this.props.id}|`;
        cookie = true;
      }
    } else if (this.ownerObj.checked === true) {
      // No cookie set yet, add current calendar id to cookie
      newCalIds = `${this.props.id}|`;
      cookie = true;
    }

    if (cookie) {
      if (window.REACT_APP_ENVIRONMENT === 'LOCAL') {
        Cookies.set(`Lefebvre.ImapCalendarsSelection`, newCalIds, {
          domain: 'localhost',
          expires: 365
        });
      } else {
        Cookies.set(`Lefebvre.ImapCalendarsSelection`, newCalIds, {
          domain: 'lefebvre.es',
          sameSite: 'None',
          secure: true,
          expires: 365
        });
      }
    }

    this.props.onClick(evt, this.props.id, this.ownerObj.checked);
  }

  makeid(length) {
    let result = '';
    const characters = 'abcdefghijklmnopqrstuvwxyz';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  render() {
    const storedSelection = Cookies.get(`Lefebvre.ImapCalendarsSelection`);
    let calIds = [];
    if (storedSelection) {
      calIds = storedSelection.split('|');
      calIds.pop();
    }
    const { name } = this.props;
    const selected = this.props.selected ? " selected" : "";
    return (
      <Fragment>
        <li
          className={` 
          text-truncate 
          text-left 
          text-dark 
          pl-2
          py-2 
          border-0 
          calendar-item-container
          ${selected}`}
          title={name}>
          <CheckBoxComponent
            cssClass={this.state.css}
            ref={checkboxObj => {
              this.ownerObj = checkboxObj;
            }}
            value={this.props.selected}
            id={this.props.id}
            label={name}
            change={this.onClick}
            checked={this.props.selected}
          />
          {(this.props.accessRole === TYPE_ROLE_CALENDAR.owner ||
          this.props.accessRole === TYPE_ROLE_CALENDAR.read_write ||
          this.props.accessRole === TYPE_ROLE_CALENDAR.read) && (
            <CalendarMenu
              key={this.props.id}
              onClick={this.navigateToList}
              name={this.props.name}
              id={this.props.id}
              color={this.props.color}
              onCalendarOpenCalnendarView={this.props.onCalendarOpenCalnendarView}
              onCalendarDelete={this.props.onCalendarDelete}
              onCalendarColorModify={this.props.onCalendarColorModify}
              isPrimary={this.props.primary}
              accessRole={this.props.accessRole}
              isIframeContainer={this.props.isIframeContainer}
            />
          )}
        </li>
        <style>
          {`
            .e-checkbox-wrapper.${this.state.css} .e-frame.e-check,
            .e-checkbox-wrapper.${this.state.css} .e-checkbox:focus + .e-frame.e-check { /* csslint allow: adjoining-classes */
              background-color: ${this.props.color} !important;
            }
            .e-checkbox-wrapper.${this.state.css}:hover .e-frame.e-check { /* csslint allow: adjoining-classes */
              background-color: ${this.props.color} !important;
            }
          `}
        </style>
      </Fragment>
    );
  }
}

export default CalendarItem;
